import React from 'react';
import PropTypes from 'prop-types';

function decodeHtml(html) {
  const parser = new DOMParser();
  return parser.parseFromString(html, 'text/html').body.textContent;
}

export default function LectureItem({ lecture, isActive, onSelect, number }) {
  const classes = `list-group-item lecture-item ${isActive ? 'active' : ''}`;

  return (
    <li className={classes} onClick={() => onSelect(lecture.id)}>
      <span className="me-2">{number}.</span>
      {decodeHtml(lecture.title)}
    </li>
  );
}

LectureItem.propTypes = {
  lecture: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
  }).isRequired,
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  number: PropTypes.number,
};

LectureItem.defaultProps = {
  isActive: false,
};
